import axiosClient from '@/axios/axiosClient';
import { ref } from 'vue';
import { localstorageGet, localstorageSet } from '@/helpers/helper';

export function useNotes() {
  const isLoading = ref(false);
  const notes = ref<string | null>(localstorageGet('shipping-msg'));

  async function getNotes(country: string) {
    isLoading.value = notes.value === null;
    const { data } = await axiosClient.get(`/shipping-msg?type=${country}`);
    isLoading.value = false;
    notes.value = data;
    localstorageSet('shipping-msg', JSON.stringify(data.value));
  }

  return {
    getNotes,
    notes,
    isLoading,
  };
}
